import { Trans } from 'react-i18next';

import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';
import { useGetTeamQuery } from '@app-velocity/libs/teams-data-access';

import { useOpenTeamBilling } from '../../hooks/useOpenTeamBilling';

export type SimulationStepsLimitNoticeProps = {
  teamId: string;
  workspaceId: string;
};

const StyledTypography = styled(Typography)`
  color: var(--text-text-primary-color);
`;

const BillingLink = styled('a')({
  textDecoration: 'underline',
  cursor: 'pointer',
  color: 'var(--text-link-primary-color)',
  '&:link,&:visited,&:hover,&:active': {
    color: 'var(--text-link-primary-color)',
  },
});

export const SimulationStepsLimitNotice = ({
  teamId,
  workspaceId,
}: SimulationStepsLimitNoticeProps) => {
  const { data: teamInfo } = useGetTeamQuery(teamId);
  const { openBilling } = useOpenTeamBilling(teamId, workspaceId);
  const stepsLimit = teamInfo?.stepsLimit;

  if (!stepsLimit) return null;

  return (
    <StyledTypography>
      <Trans
        i18nKey="shared:simulation_steps_limit"
        values={{ count: stepsLimit }}
        components={{
          tag: <strong />,
          billing: <BillingLink onClick={openBilling} />,
        }}
      />
    </StyledTypography>
  );
};
